﻿<template>

    <article class="sg-card">
        <!-- the length as a badge on the photo, as on the search results cards (tour_card.vue) -->
        <div class="sg-media">
            <img class="sg-image" :src="image()" :alt="imageAltText()">
            <span v-if="lengthBadge() != ''" class="tc-badges">
                <span class="tc-badge">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
                    {{ lengthBadge() }}
                </span>
            </span>
        </div>
        <div class="sg-body">
            <h4 class="sg-title">{{tour?.name}}</h4>
            <p class="sg-desc">{{display_description()}}</p>
            <div class="sg-actions">
                <button type="button" class="tc-link" :aria-expanded="Display_Itinerary" @click="Display_Itinerary = !Display_Itinerary">View itinerary</button>
                <button type="button" class="button button-pink-book small" @click="Full_Tour_To_Cart()">Add tour</button>
            </div>
        </div>

        <div class="lightbox" :hidden="!Display_Itinerary">
            <div class="lightbox-inner" @click.self="Display_Itinerary = false">
                <div class="lightbox-content rounded-lg shadow-lg bg-white">
                    <div class="lightbox-head flex justify-center items-center p-4 rounded-t-lg">
                        <img class="rounded-lg shadow-md" :src="image()" :alt="imageAltText()" style="height: 200px; width: 300px; object-fit: cover;">
                    </div>
                    <div class="lightbox-body p-4">
                        <p class="text-center"><button type="button" @click="Full_Tour_To_Cart()" class="button button-pink-book small">Add to cart</button></p>
                        <itinerary :tour_id="tour?.tour_id" :banner="false"></itinerary>
                        <p class="text-center"><button type="button" @click="Full_Tour_To_Cart()" class="button button-pink-book small">Add to cart</button></p>
                        <button type="button" class="close" aria-label="Close" @click="Display_Itinerary = false"></button>
                    </div>
                </div>
            </div>
        </div>

        <!-- No longer used: this pane was never opened ("Add tour" goes to the search page with ?open=),
             but it mounted a full tour_details component (twice, desktop + mobile) for every suggested tour.
                <div class="lightbox" :hidden="!Display_Add_To_Cart">
                    <div class="lightbox-inner">
                        <div class="lightbox-content">
                            <div class="lightbox-head"></div>
                            <div class="lightbox-body p-4">
                                <tour_details :trip_index="trip_index" ref="tour_details" @Add_To_Cart="Add_To_Cart"></tour_details>
                                <button class="close" @click="Display_Add_To_Cart = false"></button>
                            </div>
                        </div>
                    </div>
                </div>
        -->
    </article>

</template>

<script lang="ts" src="./tour.ts"></script>